<p-breadcrumb [model]="items" (onItemClick)="onItemSelect($event.item.id)">
  <ng-template #separator><i class="small">chevron_right</i></ng-template>
</p-breadcrumb>
